/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InfoDisplay = ({ i18n }) => {
  const cases = useSelector((state) => state.app.cases)

  const getInfoText = () => {
    try {
      let fullPaymentCases = getFullPaymentCases()
      let casesString = fullPaymentCases.length === 1 ? fullPaymentCases[0] : fullPaymentCases.join(', ')
      return i18n.language === 'en'
        ? `Case ${casesString} has been added but must be paid in full.`
        : `L'amende ${casesString} a été ajoutée, mais elle doit être payée en entier.`
    } catch (err) {
      console.log(err)
    }
  }

  const getFullPaymentCases = () => {
    return cases
      .filter((caseInfo) => {
        return caseInfo.paymentAmountFull === 'final'
      })
      .map((caseInfo) => caseInfo.caseNumber)
  }

  return getFullPaymentCases().length > 0 ? (
    <div>
      <div className="row">
        <div className="col-xs-12">
          <div class="blockquote-alert" role="alert">
            <p>
              <i class="fa fa-info-circle" aria-hidden="true"></i> {getInfoText()}
            </p>
          </div>
        </div>
      </div>
    </div>
  ) : null
}

export default withTranslation('common')(InfoDisplay)
